export var GET_TREE = 'getTree';
export var GET_ROOT_NODES = 'getRootNodes';
export var GET_CHILD_NODES = 'getChildNodes';
export var MOVE_AS_NTH_CHILD_OF = 'moveAsNthChildOf';
export var MOVE_AS_NTH_SIBLING_OF = 'moveAsNthSiblingOf';
export var ADD_ROOT_NODE = 'addRootNode';
export var ADD_CHILD_NODE = 'addChildNode';
